import React from 'react';
import './Doctor.css'

const Doctor = (props) => {
    const {img, name, expert, description}= props.doctor;
    return (
        <div className="card mb-3">
            <div className="row g-0 ">
    <div className="col-md-3">
      <img src={img} className="img-fluid rounded-start" alt="..."/>
    </div>
    <div className="col-md-7">
      <div className="card-body">
        <h5 className="card-title text-primary"><h3>{name}</h3></h5>
        <h5 className="card-title text-danger"><h4>Expertise in: {expert}</h4></h5>
        <p className="card-text"><h5>{description}</h5></p>
        <p className="card-text"><button className="btn btn-danger">Show More...</button></p>
      </div>
    </div>
  </div>
        </div>
    );
};

export default Doctor;